import { ZSpecificationTyped } from "src/business/specification";

export const mergeUniqueSchemes = (
  schemes: ZSpecificationTyped[],
): ZSpecificationTyped[] => {
  const uniqueMap: Map<string, ZSpecificationTyped> = new Map(
    schemes.map((scheme) => [scheme.id, scheme]),
  );
  return Array.from(uniqueMap.values());
};
